import {
    SET_PANEL,
    SET_FILTERS_MAP,
    SET_LOADING_MAP,
    SET_ACTION_MAP,
    SET_CONFIG_MAP,
    UPDATE_FILTER_ITEM_MAP,
    SET_USER_FEATURE_MAP,
    LOAD_STATE
 } from './mutation-types';
import {isObject} from '@config/utils'

const mutations = {
    [SET_PANEL](state, {id, ...params}) {
        let panel = null;
        let tools = state.data.tools;
        if(tools[id]){
            panel = tools[id].panel;
        }
        if(!panel){
            return;
        }
        for (const key in params) {
            if(['active', 'show', 'loaded'].includes(key)){
                params[key] = !!params[key];
            }
            if (panel.hasOwnProperty(key) && params[key] !== undefined) {
                if(isObject(panel[key]) && isObject(params[key])){
                    panel[key] = {...panel[key], ...params[key]};
                }else{
                    panel[key] = params[key];
                }
            }
        }
    },
    [SET_FILTERS_MAP](state, filters) {
        state.data.map.filters = filters;
    },
    [LOAD_STATE](state, { submodule }) {
        for (const key in submodule) {
            if (Object.hasOwnProperty.call(submodule, key)) {
                const statePart = submodule[key];
                state.data[key] = statePart;
            }
        }
    },
    [SET_LOADING_MAP](state, flag) {
        state.data.map.loading = flag;
    },
    [SET_ACTION_MAP](state, action) {
        state.data.map.action = action;
    },
    [SET_CONFIG_MAP](state, config) {
        state.data.map.config = Object.assign(state.data.map.config, config);
    },
    [UPDATE_FILTER_ITEM_MAP](state, {tp, id, show, qty, item=null}) {
        if(!item){
            item = state.data.map.filters[tp].find(item => item.id == parseInt(id));
        }
        if(show !== undefined){
            item.show = show;
        }
        if(qty !== undefined){
            item.qty = qty;
        }
    },
    [SET_USER_FEATURE_MAP](state, feature) {
        state.data.map.user_feature = feature;
    },
};

export default mutations;
